<template>
  <div class="container waitingcall">
    <section id="editContent" class="columnContainer">
      <div v-if="spaceCodeList" class="innerColumn">
        <h1 class="contentTitle">{{locale.waitingcall}}<span v-if="spaceCode"> > {{ spaceCodeName }}</span></h1>
        <div class="templateList">
          <div
            v-for="(template, index) in templateList"
            :key="index"
            class="btnTemplate"
            :data-template="template.id"
            @click="setDetail(template.id)">
            <div class="name">{{locale[`waitingcall_${template.id}`]}}</div>
            <ul class="requires">
              <li
                v-for="item in template.requires"
                :key="item">
              {{ locale[item] }}
              <i :data-status="validateTemplate(template.id, item)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="innerColumn">
        <div class="noData">{{ locale.waitingcall_spacecode_nodata }}</div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <div v-if="spaceCodeList" class="pageNav">
          <button
            v-for="space in spaceCodeList"
            :key="space.id"
            type="button"
            class="mb15 btn btnFull toCapitalize"
            :class="{btnWhite: space.id !== spaceCode}"
            @click="setSpaceCode(space.id)">
            {{ space.name }}
          </button>
        </div>
      </div></div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" :disabled="!spaceCode" @click="onSave">{{locale.save}}</button>
      </div>
    </div>
    <WaitingcallDetail
      v-if="detailData && detailInfo"
      :locale="locale"
      :lang="lang"
      :detailInfo="detailInfo"
      :detailData="detailData"
      @apply="applyDetail"
      @close="closeDetail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import WaitingcallDetail from '@/components/Waitingcall/Detail'

const defaultSteps = {
  tnc: { // 마케팅 동의 및 t&c
    title: LANG.valueObj(''),
    desc: LANG.valueObj('')
  },
  auth: { // 예약정보 조회
    title: LANG.valueObj(''),
    desc: LANG.valueObj(''),
    domestic: ['phone'],
    foreign: ['email'],
    domesticLang: '',
    foreignLang: '',
    customFields: []
  },
  confirm: { // 예약정보 확인
    confirm: LANG.valueObj(''),
    waitingcall_result_complete: LANG.valueObj(''),
    waitingcall_result_already: LANG.valueObj('')
  },
  status: { // 웨이팅 조회
    title: LANG.valueObj(''),
    desc: LANG.valueObj(''),
    messageWAIT: LANG.valueObj(''),
    messageASSIGN: LANG.valueObj(''),
    messageCALL: LANG.valueObj(''),
    messageCOMPLETE: LANG.valueObj('')
  },
  setting: {
    entranceActive: false,
    entranceUrl: {
      type: 'page',
      pageId: '',
      url: LANG.valueObj(),
      productId: '',
      target: false,
      pageId_input_active: false
    }
  },
  info: {
    name: LANG.valueObj('')
  }
}

export default {
  name: 'Waitingcall',
  props: [
    'locale',
    'spaceCode'
  ],
  components: {
    WaitingcallDetail
  },
  computed: {
    ...mapGetters({
      settingData: 'setting/getData',
      getWaitingcallResultData: "waitingcall/getWaitingcallResultData"
    }),
    lang () {
      return this.settingData.lang
    },
    spaceCodeName () {
      const spaceCode = this.spaceCode
      const spaceCodeList = this.spaceCodeList
      const current = spaceCode && spaceCodeList && spaceCodeList.find(x => x.id === spaceCode)
      return current ? current.name : ''
    },
    templateList () {
      const spaceCode = this.spaceCode
      const space = spaceCode && this.waitingcall && this.waitingcall[spaceCode]
      const templateOrder = ['info', 'setting', 'tnc', 'auth', 'confirm', 'apply', 'status'] // 순서정렬
      const notContent = /domestic|foreign|entrance|customFields|showWaitingcallList/ // 컨텐츠가 아니어서 템플릿으로 밸리데이션 할 필요 없음
      const list = space && Object.keys(space).map(x => {
        return {
          id: x,
          requires: Object.keys(space[x]).filter(x => !notContent.test(x))
        }
      })
      return list ? list.sort((a, b) => templateOrder.indexOf(a.id) - templateOrder.indexOf(b.id)) : null
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      spaceCodeList: [],
      waitingcall: null,
      detailData: null,
      detailInfo: null,
      message: null,
      spaceCodeTypes: [ // 추후에 있을지 모르는 웨이팅 타입 (default: checkin)
        'checkin'
      ]
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.userInfo.siteid
      const routerPath = this.$route.path
      const talk = this.$route.params.talk
      const path = `${site}${routerPath}`
      const title = `waitingcall tempalte`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    async init () {
      // spaceCode 호출
      const getSpaceCode = await this.$store.dispatch('waitingcall/getSpaceCodeList')
      const spaceCode = getSpaceCode && getSpaceCode.message && getSpaceCode.message.spaceCodes
      // waitingcall 문구 데이터 json
      const getWaitingcallData = await this.$store.dispatch('waitingcall/getWaitingcallData')
      const waitingcallData = getWaitingcallData || null
      if (spaceCode && spaceCode.length) {
        if (!this.$route.params.spaceCode) {
          this.setSpaceCode(spaceCode[0].spaceCode)
        }
        this.spaceCodeList = spaceCode.map(x => {
          return {
            id: x.spaceCode,
            name: x.spaceName,
            use: x.use
          }
        })
        this.setTemplateData(waitingcallData)
      } else {
        const status = (getSpaceCode && getSpaceCode.data && getSpaceCode.data.status) || 500
        const message = this.getWaitingcallResultData(status)
        // alert(message)
        this.spaceCodeList = null
      }
    },
    setSpaceCode (spaceCode) {
      if (spaceCode) {
        this.$router.push({
          params: { spaceCode: spaceCode }
        })
      }
    },
    setTemplateData (waitingcallData) {
      const spaceCodeList = this.spaceCodeList
      this.waitingcall = {}
      spaceCodeList.map(x => x.id).map(x => {
        this.waitingcall[x] = Object.keys(defaultSteps).reduce((acc, key) => {
          acc[key] = {
            ...defaultSteps[key],
            ...waitingcallData && waitingcallData[x] && waitingcallData[x][key],
          }
          return acc
        }, {})
      })
    },
    validateTemplate (detail, template) {
      const spaceCode = this.spaceCode
      const target = this.waitingcall && this.waitingcall[spaceCode]
      const targetDetail = target && target[detail]
      const targetTemplate = targetDetail && targetDetail[template]
      const isManualLang = lang => this.lang && this.lang.manual.includes(lang) && this.lang.usable.includes(lang)
      const isEmpty = str => regExp.replaceAllEmpty(str).length === 0
      const requiresLength = Object.keys(targetTemplate).filter(lang => {
        return isManualLang(lang)
      }).length
      const emptyLength = Object.keys(targetTemplate).filter(lang => {
        return isManualLang(lang) && isEmpty(targetTemplate[lang])
      }).length
      return emptyLength === 0
        ? 1 // 모두 값이 있음?
        : requiresLength === emptyLength
          ? 0 // 모두 값이 없음?
          : 2 // 일부만 값이 있음?
    },
    setDetail (detail) {
      const spaceCode = this.spaceCode
      const copyData = this.waitingcall[spaceCode][detail]
      const defaultLang = this.$store.getters['setting/getData'].lang.default
      this.detailData = {
        ...copyData,
        ...detail === 'auth' && {
          domesticLang: (copyData.domesticLang) || defaultLang,
          foreignLang: (copyData.foreignLang) || 'en'
        }
      }
      this.detailInfo = {
        name: this.spaceCodeName,
        template: detail
      }
    },
    async applyDetail (data) {
      const spaceCode = this.spaceCode
      const template = this.detailInfo.template
      this.waitingcall[spaceCode][template] = {
        ...this.waitingcall[spaceCode][template],
        ...data
      }
      this.closeDetail()
      this.onSave(true)
    },
    closeDetail () {
      this.detailData = null
      this.detailInfo = null
    },
    async onSave (directSave) {
      if (directSave || window.confirm(this.locale.confirm_save)) {
        this.$store.commit('onLoading', true)
        this.$store.dispatch('waitingcall/setWaitingcallData', this.waitingcall).then((res) => {
          alert(this.locale.complete_save)
          this.init()
          this.$store.commit('onLoading', false)
        })
      }
    }
  }
}
</script>
